import { css } from 'styled-components';
import breakPoints from '../../../themes/breakpoints';
var SocialIconStyles = css(["", ";"], function (props) {
  return props.styleType === 'staff-social-link' ? "\n      text-align: left;\n      margin-bottom:30px;\n\n      @media only screen and (max-width: ".concat(breakPoints.mobile, ") {\n        text-align: center;\n      }\n      ") : '';
});
export default SocialIconStyles;